import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Checklist } from '../classes/checklist';
import config from '../config.json';

@Injectable({
    providedIn: 'root'
})
export class ChecklistService {
    API_CHECKLIST_URL = config.serverAddress + ':' + config.serverPort + '/checklist/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CHECKLIST_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_CHECKLIST_URL + id);
    }
    duplicate(checklist: Checklist) {
        return this.http.post(this.API_CHECKLIST_URL + 'duplicate', checklist);
    }
    create(checklist: Checklist) {
        return this.http.post(this.API_CHECKLIST_URL + 'create', checklist);
    }
    update(checklist: Checklist) {
        return this.http.put(this.API_CHECKLIST_URL + 'update', checklist);
    }
    delete(id: number | null) {
        return this.http.delete(this.API_CHECKLIST_URL + 'delete/' + id);
    }
}
